import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, FilterIcon, ShieldAlertIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
const ChargebackManagement: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  // Mock Data
  const chargebacks = [{
    id: 'CB-2023-001',
    disputeId: 'DSP-2023-007',
    merchant: 'TechStore PK',
    amount: 32000,
    date: '2023-10-25',
    liability: 'Merchant Liable',
    status: 'Processed'
  }, {
    id: 'CB-2023-002',
    disputeId: 'DSP-2023-012',
    merchant: 'Global Mart',
    amount: 15500,
    date: '2023-10-24',
    liability: 'Acquirer Liable',
    status: 'Pending Settlement'
  }, {
    id: 'CB-2023-003',
    disputeId: 'DSP-2023-015',
    merchant: 'Fashion Hub',
    amount: 8900,
    date: '2023-10-23',
    liability: 'Merchant Liable',
    status: 'Processed'
  }, {
    id: 'CB-2023-004',
    disputeId: 'DSP-2023-018',
    merchant: 'Travel Agency',
    amount: 125000,
    date: '2023-10-22',
    liability: 'Merchant Liable',
    status: 'Pending Settlement'
  }, {
    id: 'CB-2023-005',
    disputeId: 'DSP-2023-022',
    merchant: 'Electro World',
    amount: 45000,
    date: '2023-10-21',
    liability: 'Acquirer Liable',
    status: 'Processed'
  }];
  const filteredChargebacks = chargebacks.filter(c => c.id.toLowerCase().includes(searchTerm.toLowerCase()) || c.merchant.toLowerCase().includes(searchTerm.toLowerCase()) || c.disputeId.toLowerCase().includes(searchTerm.toLowerCase()));
  const columns = [{
    header: 'Chargeback ID',
    accessor: 'id',
    sortable: true,
    className: 'font-medium text-gray-900 dark:text-white'
  }, {
    header: 'Dispute Ref',
    accessor: 'disputeId',
    sortable: true,
    className: 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline'
  }, {
    header: 'Merchant',
    accessor: 'merchant',
    sortable: true
  }, {
    header: 'Amount',
    accessor: (row: any) => `PKR ${row.amount.toLocaleString()}`,
    sortable: true
  }, {
    header: 'Date Initiated',
    accessor: 'date',
    sortable: true
  }, {
    header: 'Liability',
    accessor: (row: any) => <span className={`font-medium ${row.liability === 'Merchant Liable' ? 'text-orange-600 dark:text-orange-400' : 'text-purple-600 dark:text-purple-400'}`} data-id="element-3703">
          {row.liability}
        </span>,
    sortable: true
  }, {
    header: 'Status',
    accessor: (row: any) => <StatusBadge status={row.status === 'Processed' ? 'success' : 'warning'} text={row.status} data-id="element-3704" />,
    sortable: true
  }];
  return <div className="space-y-6" data-id="element-3705">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-3706">
        <div data-id="element-3707">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-3708">
            Chargeback Management
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-3709">
            Track and manage scheme-initiated chargebacks and liability
            assignments.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3710">
        <Card className="bg-orange-50 dark:bg-orange-900/20 border-orange-100 dark:border-orange-800" data-id="element-3711">
          <div className="flex items-center" data-id="element-3712">
            <div className="p-3 rounded-full bg-orange-500 text-white mr-4" data-id="element-3713">
              <ShieldAlertIcon className="h-6 w-6" data-id="element-3714" />
            </div>
            <div data-id="element-3715">
              <p className="text-sm font-medium text-orange-600 dark:text-orange-400" data-id="element-3716">
                Merchant Liable (MTD)
              </p>
              <p className="text-2xl font-bold text-orange-900 dark:text-orange-100" data-id="element-3717">
                PKR 1.2M
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-purple-50 dark:bg-purple-900/20 border-purple-100 dark:border-purple-800" data-id="element-3718">
          <div className="flex items-center" data-id="element-3719">
            <div className="p-3 rounded-full bg-purple-500 text-white mr-4" data-id="element-3720">
              <ShieldAlertIcon className="h-6 w-6" data-id="element-3721" />
            </div>
            <div data-id="element-3722">
              <p className="text-sm font-medium text-purple-600 dark:text-purple-400" data-id="element-3723">
                Acquirer Liable (MTD)
              </p>
              <p className="text-2xl font-bold text-purple-900 dark:text-purple-100" data-id="element-3724">
                PKR 145K
              </p>
            </div>
          </div>
        </Card>
        <Card className="bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-800" data-id="element-3725">
          <div className="flex items-center" data-id="element-3726">
            <div className="p-3 rounded-full bg-blue-500 text-white mr-4" data-id="element-3727">
              <ShieldAlertIcon className="h-6 w-6" data-id="element-3728" />
            </div>
            <div data-id="element-3729">
              <p className="text-sm font-medium text-blue-600 dark:text-blue-400" data-id="element-3730">
                Total Chargebacks (MTD)
              </p>
              <p className="text-2xl font-bold text-blue-900 dark:text-blue-100" data-id="element-3731">
                42
              </p>
            </div>
          </div>
        </Card>
      </div>

      <Card data-id="element-3732">
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-6" data-id="element-3733">
          <div className="relative flex-1 max-w-md" data-id="element-3734">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3735">
              <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-3736" />
            </div>
            <input type="text" placeholder="Search Chargebacks..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-3737" />
          </div>
          <div className="flex items-center space-x-2" data-id="element-3738">
            <FilterIcon className="h-5 w-5 text-gray-400" data-id="element-3739" />
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md dark:bg-gray-800 dark:text-white" data-id="element-3740">
              <option data-id="element-3741">All Liabilities</option>
              <option data-id="element-3742">Merchant Liable</option>
              <option data-id="element-3743">Acquirer Liable</option>
            </select>
          </div>
        </div>

        <Table columns={columns} data={filteredChargebacks} keyField="id" onRowClick={row => navigate(`/disputes/${row.disputeId}`)} data-id="element-3744" />
      </Card>
    </div>;
};
export default ChargebackManagement;